import { ReactNode } from 'react';

import { Dialog, dialog } from '@flipster/react/design-system/dialog';
import InformationCircleIcon from '@flipster/react/icon/generated/InformationCircleIcon';
import { checkAxiosError } from '@flipster/utils/axios';
import { isServer } from '@flipster/utils/env-helper';
import { getErrorMessage } from '@flipster/utils/error';

export interface AlertProps {
  warn?: boolean;
  title?: ReactNode;
  message: ReactNode;
  onConfirm?: () => void;
  confirmText?: ReactNode;
  onClose?: () => void;
  closeText?: ReactNode;
  withClose?: boolean;
}

/**
 * @deprecated 이 객체는 임시로만 사용하세요. 대신 `dialog`를 직접 사용하는 것을 권장합니다.
 */
export const alert = {
  show({
    warn,
    title,
    message,
    onConfirm,
    confirmText = 'Confirm',
    onClose,
    closeText = 'Close',
    withClose,
  }: AlertProps) {
    dialog.open({
      title: { leftAddon: warn ? <InformationCircleIcon color='#faad14' /> : undefined, label: title ?? 'Notice' },
      content: message,
      buttons: {
        primary: <Dialog.Button hierarchy='primary' label={confirmText} onClick={onConfirm} />,
        secondary: withClose ? (
          <Dialog.Button hierarchy='secondary' color='neutral' label={closeText} onClick={onClose} />
        ) : undefined,
      },
    });
  },
  clear() {
    dialog.close();
  },
  error(err: unknown, options: { onlyAxiosError?: boolean } = {}) {
    if (options.onlyAxiosError && !checkAxiosError(err)) return;
    if (!isServer && window.location.pathname === '/maintenance') {
      this.clear();
      return;
    }
    const message = getErrorMessage(err);
    if (message) this.show({ message });
  },
};
